export default "https://cdn-static.gokick.com/assets/9d5d62c9c10b295872f7f6ffd14ff177054c61a9/images/citrus-zen.2d0942f5031f42be498b3d61071e3237.png";